import React, { useEffect, useRef } from "react";

const SummernoteEditor = ({ initialValue = "", onChange }) => {
  const editorRef = useRef(null);
  const initialized = useRef(false);

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });

  const loadCSS = (href) => {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  };

  useEffect(() => {
    const init = async () => {
      if (initialized.current) return;
      initialized.current = true;

      // Load CSS
      loadCSS(
        "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.4.1/css/bootstrap.min.css",
      );
      loadCSS("https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.12/summernote.css");

      // Load scripts in sequence
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js");
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.4.1/js/bootstrap.min.js",
      );
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.12/summernote.min.js",
      );

      const $ = window.jQuery;
      if (typeof $.fn.summernote !== "function") {
        console.error("❌ Summernote plugin missing after load.");
        return;
      }

      // Initialize Summernote ONCE
      $(editorRef.current).summernote({
        height: 250,
        placeholder: "Write something awesome...",
        callbacks: {
          onChange: (contents) => {
            onChange?.(contents);
          },
        },
      });

      $(editorRef.current).summernote("code", initialValue);
    };

    init();

    // ✅ Cleanup only on component unmount
    return () => {
      const $ = window.jQuery;
      if ($ && editorRef.current && $(editorRef.current).next(".note-editor").length) {
        $(editorRef.current).summernote("destroy");
      }
    };
  }, []); // ❗ Empty dependency array — run once only

  return <textarea ref={editorRef} />;
};

export default SummernoteEditor;
